import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    formNavigationHistoryBySlot: {},
    operationalProcessItems: [],
    nextOperationalProcessId: 1,
  },
  getters: {
    // Get navigation history for a specific slot
    getFormNavigationHistory: (state) => (slotId = 'main') => {
      return state.formNavigationHistoryBySlot[slotId] || [];
    },

    // Check if a slot has navigation history (needs at least 1 item to go back to)
    hasNavigationHistory: (state) => (slotId = 'main') => {
      const history = state.formNavigationHistoryBySlot[slotId] || [];
      return history.length > 0;
    },

    // Get the previous form for a specific slot
    getPreviousForm: (state) => (slotId = 'main') => {
      const history = state.formNavigationHistoryBySlot[slotId] || [];
      if (history.length > 0) {
        return history[history.length - 1];
      }
      return null;
    },

    // Operational process items
    getOperationalProcessItems(state) {
      return state.operationalProcessItems;
    },
  },
  mutations: {
    // Push a form to the history of a specific slot
    pushFormToHistory(state, { slotId = 'main', formData }) {
      if (!state.formNavigationHistoryBySlot[slotId]) {
        Vue.set(state.formNavigationHistoryBySlot, slotId, []);
      }
      state.formNavigationHistoryBySlot[slotId].push({
        id: formData.id,
        data: formData.data
      });
    },

    // Pop a form from the history of a specific slot
    popFormFromHistory(state, slotId = 'main') {
      if (state.formNavigationHistoryBySlot[slotId] &&
        state.formNavigationHistoryBySlot[slotId].length > 0) {
        return state.formNavigationHistoryBySlot[slotId].pop();
      }
    },

    // Clear navigation history for a specific slot
    clearFormNavigationHistory(state, slotId = 'main') {
      if (slotId) {
        Vue.set(state.formNavigationHistoryBySlot, slotId, []);
      }
    },

    // Clear all navigation history
    clearAllNavigationHistory(state) {
      state.formNavigationHistoryBySlot = {};
    },

    // Operational process mutations
    addOperationalProcessItem(state, formData) {
      const item = {
        id: state.nextOperationalProcessId++,
        ...formData,
        actividades_tipo_atencion: formData.actividades || [],
        sistemas: formData.sistemas || [],
      };
      state.operationalProcessItems.unshift(item);
    },

    removeOperationalProcessItem(state, id) {
      state.operationalProcessItems = state.operationalProcessItems.filter(
        item => item.id !== id
      );
    },

    updateOperationalProcessItem(state, { id, data }) {
      const idx = state.operationalProcessItems.findIndex(item => item.id === id);
      if (idx !== -1) {
        Vue.set(state.operationalProcessItems, idx, {
          ...state.operationalProcessItems[idx],
          ...data,
        });
      }
    },
  },
  actions: {
    // Navigate to a form (add to history)
    navigateToForm({ commit }, { slotId = 'main', formData }) {
      commit('pushFormToHistory', { slotId, formData });
    },

    // Navigate back (remove from history and return previous form)
    navigateBack({ commit, state }, slotId = 'main') {
      const history = state.formNavigationHistoryBySlot[slotId];
      if (history && history.length > 0) {
        const previousForm = history[history.length - 1];
        commit('popFormFromHistory', slotId);
        return previousForm;
      }
      return null;
    },

    // Clear history for a specific slot
    clearHistory({ commit }, slotId = 'main') {
      commit('clearFormNavigationHistory', slotId);
    },

    clearAllHistory({ commit }) {
      commit('clearAllNavigationHistory');
    },
  }
}
